import Registry from "./Registry";

export default class Popup {

    static get(selector) {

        let instance = Registry.get('Popup', selector);
        if (instance)
            return instance;

        instance = new Popup(selector);
        Registry.set('Popup', selector, instance);

        return instance;

    }

    constructor(selector) {

        this.selector = selector;

        if (typeof selector === 'string')
            this.popup = $(this.selector);
        else
            this.popup = this.selector;

        this.defaults = {
            title: this.popup.find('.title h2').length ? this.popup.find('.title h2').text() : 'Заполните заявку на обратную связь',
            button: 'Отправить',
            animationTime: 250,
            success: 'Спасибо за вашу заявку.<br>'+
                'В ближайшее время с Вами свяжется наш специалист.',
            error: 'Извините. Произошла ошибка. Повторите позднее.',
        };

        this.isFeedbackForm = true;

        return this;
    }

    setValues(btn) {

        const title = btn ? (btn.attr('popup-title') ? btn.attr('popup-title') : this.defaults.title) : this.defaults.title,
            text = btn ? (btn.attr('popup-button') ? btn.attr('popup-button') : this.defaults.button) : this.defaults.button;

        this.popup.find('.title h2').text(title);

        if (this.isFeedbackForm) {
            this.popup.find('[type="submit"]').text(text);
        }
        this.changeTitle(title);
        if (btn && btn.length && btn[0].attributes) this.changeHiddenValues(btn);

    }

    changeHiddenValues(button) {

        for (let i = 0; i < button[0].attributes.length; i++) {

            const key = button[0].attributes[i].nodeName;
            const val = button[0].attributes[i].nodeValue;

            if (key.indexOf('popup-') === 0) this.changeHiddenValue(key.slice(6), val);

        }
    }

    changeHiddenValue(name, val) {

        const hidden = this.popup.find('[name="' + name + '"]');

        if (!hidden.length)
            this.popup.find('form').prepend('<input type="hidden" class="added" name="' + name + '" value="' + val + '" >');
        else
            this.popup.find('[name="' + name + '"]').val(val);

    }

    changeTitle(title) {

        if (!this.popup.find('[name="title"]').length)
            this.popup.find('form').append('<input type="hidden" name="title">');

        this.popup.find('[name="title"]').val(title);

    }

    show(button) {
        (dataLayer = window.dataLayer || []).push({
            'event': 'UAEvent',
            'ga_eventname': 'form-open-callback',
            'eCategory':'form',
            'eAction': 'open',
            'eLabel': 'callback',
            'eNi': '0'});
        clearTimeout(this.timeout);
        this.setValues(button);
        this.popup.addClass('open');
        $('html').addClass('no-scroll');
    }

    close() {

        const self = this;
        self.popup.removeClass('open');
        $('html').removeClass('no-scroll');

        self.timeout = setTimeout(function () {
            self.setValues(null);
        }, self.defaults.animationTime);

    }

    static message(text, type) {
        const popup = Popup.get($('#popup-message'));
        type = type ? type : 'success';
        $('#popup-message').find('.popup__text').html(text ? text : popup.defaults[type]);
        popup.show();
    }

}

$('.car-list__item').on('click', function() {
    let model = $(this).attr('id');
    console.log(model);
    $('#popup form input[name=model]').val(model);
});